/**
 * Document and Camera Capture Constants
 * Centralized configuration for capture-related magic numbers
 */

// Camera preview dimensions
export const CAMERA_PREVIEW = {
  // Maximum width for camera preview containers
  MOBILE_MAX_WIDTH: '320px',
  TABLET_MAX_WIDTH: '360px',
  DESKTOP_MAX_WIDTH: '400px',

  // Aspect ratios
  ASPECT_RATIO: '16/10',
  ID_CARD_ASPECT_RATIO: 1.586, // Standard ID card width/height ratio

  // Guide zone scaling
  MOBILE_GUIDE_ZONE_SCALE: 0.9,
  DESKTOP_GUIDE_ZONE_SCALE: 0.85,
  GUIDE_ZONE_MAX_HEIGHT_RATIO: 0.8,

  // Buffer for capture (ensures full document is captured)
  CAPTURE_BUFFER_FACTOR: 0.1,
} as const;

// Animation and transition delays
export const DELAYS = {
  // Camera initialization
  CAMERA_INIT_DELAY: 500,
  CAMERA_RETRY_DELAY: 100,

  // Mobile-specific delays
  MOBILE_VIDEO_READY_DELAY: 200,
  DESKTOP_VIDEO_READY_DELAY: 100,
  MOBILE_ORIENTATION_CHANGE_DELAY: 100,

  // Capture and transition delays
  FLASH_EFFECT_DURATION: 200,
  CAPTURE_SUCCESS_DELAY: 1200,
  TRANSITION_DELAY: 300,

  // Processing timeouts
  VIDEO_LOADING_TIMEOUT: 3000,
  PROCESSING_TIMEOUT: 30000,
} as const;

// UI element sizes
export const SIZES = {
  // Guide corner indicators
  CORNER_INDICATOR_SIZE: '20px',
  CORNER_BORDER_WIDTH: '3px',

  // Border radius
  CAMERA_CONTAINER_RADIUS: '12px',
  GUIDE_ZONE_RADIUS: '8px',
} as const;

// Quality settings
export const QUALITY = {
  // JPEG compression quality
  IMAGE_COMPRESSION_QUALITY: 0.95,

  // Camera quality settings
  DOCUMENT_CAMERA_QUALITY: 'high',
  SELFIE_CAMERA_QUALITY: 'high',
} as const;
